import React from "react";
import styled from "styled-components";
import {ReactComponent as Puntos} from './../imagenes/puntos.svg'

const Contenedor = styled.div`
    background: #fff;
    width: 95%;
    max-width: 130rem; /*2060px*/
    height: 95vh;
    max-height: 65rem;  /* 880px */
    overflow-y: auto;
    box-shadow: 0px 1.25rem 2.5rem rgba(0,0,0,.05);
    border-radius: 0.625rem; /* 10px */
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    z-index: 100;
 
    @media(max-width: 60rem){ /* 950px */
        height: 98vh;
        max-height: none;
    }
`;
const Svg = styled.svg`
    height: 50vh;
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 0;
    path {
        fill: rgba(135,182,194, .15);
    }
`;

const PuntosArriba = styled(Puntos)`
    position: fixed;
    z-index: 1;
    top: 2.5rem; /* 40px */
    left: 2.5rem; /* 40px */
`;
 
const PuntosAbajo = styled(Puntos)`
    position: fixed;
    z-index: 1;
    bottom: 2.5rem; /* 40px */
    right: 2.5rem; /* 40px */
`;


const Fondo = () => {
    return (  
        <>
            <PuntosArriba></PuntosArriba>

            <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" 
            preserveAspectRatio="none">
                <path 
                    fill="#000b76" 
                    fillOpacity="1" 
                    d="M0,128L48,117.3C96,107,192,85,288,96C384,107,480,149,576,181.3C672,213,768,235,864,224C960,213,1056,171,1152,138.7C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
                </path>
            </Svg>
            <PuntosAbajo></PuntosAbajo>
        </>
    );
}


export {Contenedor, Fondo};